export const defaultMessages = {
  region:
    'В целях противодействия распространению новой коронавирусной инфекции, прием и обслуживание налогоплательщиков в выбранном регионе приостановлены.',
  ifns:
    'Выбранный Вами налоговый орган, в целях противодействия распространению новой коронавирусной инфекции, приостановил прием и обслуживание налогоплательщиков.',
};
